<template>
    <div>
        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>账号详情</h2>
            <span style="margin-left: 20px;">用户id：{{ userData.userId }}</span>
        </div>
        <Form @submit.native.prevent label-position="right" :label-colon="true" :label-width="150">
            <Row :gutter="24">
                <!-- <Col :span="8">
                <FormItem label="限制登录">1</FormItem>
                </Col> -->
                <Col :span="8">
                <FormItem label="注册时间">{{ userData.createTimeFmt||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="注册IP地址">{{ userData.registerIp||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="是否注销">{{ !userData.enabled?'是':'否' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="最后登录时间">{{ userData.lastLoginTimeFmt||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="最后登录IP地址">{{ userData.lastLoginIp||'-' }}</FormItem>
                </Col>
            </Row>
        </Form>

        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>设备信息</h2>
        </div>
        <Form @submit.native.prevent label-position="right" :label-colon="true" :label-width="150">
            <Row :gutter="24">
                <Col :span="24">
                <FormItem label="设备系统">{{ userData.deviceSysName||'-' }}</FormItem>
                </Col>
                <!-- <Col :span="8">
                <FormItem label="设备信息">{{ userData. }}</FormItem>
                </Col> -->
                <Col :span="16">
                <FormItem label="设备SN">{{ userData.deviceSn||'-' }}</FormItem>
                </Col>
                <!-- <Col :span="8">
                <FormItem label="设备类型">{{ userData. }}</FormItem>
                </Col> -->
                <Col :span="8">
                <FormItem label="设备IMEI">{{ userData.deviceImei||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="设备IDFA">{{ userData.deviceIdfa||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="应用版本">{{ userData.appVersion||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="设备OAID">{{ userData.deviceOaid||'-' }}</FormItem>
                </Col>
                <Col :span="8">
                <FormItem label="设备IDFV">{{ userData.deviceIdfv||'-' }}</FormItem>
                </Col>
                <Col :span="24">
                <FormItem label="设备UA">{{ userData.deviceUa||'-' }}</FormItem>
                </Col>
            </Row>
        </Form>

        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>登录日志</h2>
        </div>
        <Table :columns="columns1" :data="userData.loginLog"></Table>

        <div style="display:flex; align-items: baseline;margin: 20px 0">
            <h2>账号绑定</h2>
        </div>
        <Table :columns="columns2" :data="userData.bindInfo"></Table>
    </div>
</template>

<script>
export default {
  props:{
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData1:[],
      columns1: [
        {
          title:'id',
          key:'id'
        },
        {
          title:'设备平台',
          key: 'deviceSysName'
        },
        {
          title:'IP',
          key: 'loginIp'
        },
        {
          title:'创建时间',
          key: 'createTimeFmt'
        }
      ],
      tableData2:[],
      columns2: [
        {
          title:'注册类型',
          render: (h,params)=>{
            return <div>
                {params.row.bindTypeName?params.row.bindTypeName:'-'}
              </div>
          },
          key: 'bindTypeName'
        },
        {
          title:'邮箱',
          render: (h,params)=>{
            return <div>
                {params.row.thirdEmail?params.row.thirdEmail:'-'}
              </div>
          },
          key: 'thirdEmail'
        },
        {
          title:'登录编号',
          render: (h,params)=>{
            return <div>
                {params.row.thirdId?params.row.thirdId:'-'}
              </div>
          },
          key: 'thirdId'
        },
        {
          title:'姓名',
          render: (h,params)=>{
            return <div>
                {params.row.thirdName?params.row.thirdName:'-'}
              </div>
          },
          key: 'thirdName'
        },
        {
          key: 'bindAppId',
          render: (h,params)=>{
            return <div>
                {params.row.bindAppId?params.row.bindAppId:'-'}
              </div>
          },
          title:'应用id'
        },
        {
          key: 'bindAppKey',
          render: (h,params)=>{
            return <div>
                {params.row.bindAppKey?params.row.bindAppKey:'-'}
              </div>
          },
          title:'应用key'
        },
        {
          key: 'bindStatusName',
          render: (h,params)=>{
            return <div>
                {params.row.bindStatusName?params.row.bindStatusName:'-'}
              </div>
          },
          title:'状态'
        },
        {
          key: 'createTimeFmt',
          render: (h,params)=>{
            return <div>
                {params.row.createTimeFmt?params.row.createTimeFmt:'-'}
              </div>
          },
          title:'创建时间'
        }
      ]
    }
  }
}
</script>
